import { RegionId } from '../region-id.enum';
import { StripeProductType } from '../stripe-product-type';
import { RequiredDesignFileTemplateBody } from './required-design-file-template-body.model';

export interface RequiredDesignFileTemplateResponse {
    readonly id: number;
    readonly name: string;
    readonly isActive: boolean;
    readonly parentTemplateId?: number | null;
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentSubTypeOriginalId?: number | null;
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: RegionId | null;
    readonly stripeProductType?: StripeProductType | null;
    readonly body: RequiredDesignFileTemplateBody;
    readonly createdDate: string;
    readonly modifiedDate: string;
    readonly createdBy?: string | null;
    readonly modifiedBy?: string | null;
}
